module.exports = __webpack_public_path__ + "img/kleisma1m.42df3cb2.jpg";